// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file qf/types.proto (package qf, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { BuildInfo, Score } from "../kit/score/score_pb";
import { file_kit_score_score } from "../kit/score/score_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file qf/types.proto.
 */
export const file_qf_types: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_kit_score_score]);

/**
 * @generated from message qf.User
 */
export type User = Message<"qf.User"> & {
  /**
   * @generated from field: uint64 ID = 1;
   */
  ID: bigint;

  /**
   * @generated from field: bool IsAdmin = 2;
   */
  IsAdmin: boolean;

  /**
   * @generated from field: string Name = 3;
   */
  Name: string;

  /**
   * @generated from field: string StudentID = 4;
   */
  StudentID: string;

  /**
   * @generated from field: string Email = 5;
   */
  Email: string;

  /**
   * @generated from field: string AvatarURL = 6;
   */
  AvatarURL: string;

  /**
   * @generated from field: string Login = 7;
   */
  Login: string;

  /**
   * Filter; True if user's JWT token needs to be updated.
   *
   * @generated from field: bool UpdateToken = 8;
   */
  UpdateToken: boolean;

  /**
   * Filter; The user's ID on the remote provider.
   *
   * @generated from field: uint64 ScmRemoteID = 9;
   */
  ScmRemoteID: bigint;

  /**
   * Filter; The user's refresh token that may be exchanged for an access token.
   *
   * @generated from field: string RefreshToken = 10;
   */
  RefreshToken: string;

  /**
   * @generated from field: repeated qf.Enrollment Enrollments = 11;
   */
  Enrollments: Enrollment[];

  /**
   * @generated from field: repeated qf.FeedbackReceipt FeedbackReceipts = 12;
   */
  FeedbackReceipts: FeedbackReceipt[];
};

/**
 * Describes the message qf.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_qf_types, 0);

/**
 * @generated from message qf.Users
 */
export type Users = Message<"qf.Users"> & {
  /**
   * @generated from field: repeated qf.User users = 1;
   */
  users: User[];
};

/**
 * Describes the message qf.Users.
 * Use `create(UsersSchema)` to create a new message.
 */
export const UsersSchema: GenMessage<Users> = /*@__PURE__*/
  messageDesc(file_qf_types, 1);

/**
 * @generated from message qf.Group
 */
export type Group = Message<"qf.Group"> & {
  /**
   * @generated from field: uint64 ID = 1;
   */
  ID: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: uint64 courseID = 3;
   */
  courseID: bigint;

  /**
   * @generated from field: qf.Group.GroupStatus status = 5;
   */
  status: Group_GroupStatus;

  /**
   * @generated from field: repeated qf.User users = 6;
   */
  users: User[];

  /**
   * @generated from field: repeated qf.Enrollment enrollments = 7;
   */
  enrollments: Enrollment[];

  /**
   * @generated from field: repeated qf.UsedSlipDays usedSlipDays = 8;
   */
  usedSlipDays: UsedSlipDays[];

  /**
   * @generated from field: uint32 slipDaysRemaining = 9;
   */
  slipDaysRemaining: number;
};

/**
 * Describes the message qf.Group.
 * Use `create(GroupSchema)` to create a new message.
 */
export const GroupSchema: GenMessage<Group> = /*@__PURE__*/
  messageDesc(file_qf_types, 2);

/**
 * @generated from enum qf.Group.GroupStatus
 */
export enum Group_GroupStatus {
  /**
   * @generated from enum value: PENDING = 0;
   */
  PENDING = 0,

  /**
   * @generated from enum value: APPROVED = 1;
   */
  APPROVED = 1,
}

/**
 * Describes the enum qf.Group.GroupStatus.
 */
export const Group_GroupStatusSchema: GenEnum<Group_GroupStatus> = /*@__PURE__*/
  enumDesc(file_qf_types, 2, 0);

/**
 * @generated from message qf.Groups
 */
export type Groups = Message<"qf.Groups"> & {
  /**
   * @generated from field: repeated qf.Group groups = 1;
   */
  groups: Group[];
};

/**
 * Describes the message qf.Groups.
 * Use `create(GroupsSchema)` to create a new message.
 */
export const GroupsSchema: GenMessage<Groups> = /*@__PURE__*/
  messageDesc(file_qf_types, 3);

/**
 * @generated from message qf.Course
 */
export type Course = Message<"qf.Course"> & {
  /**
   * @generated from field: uint64 ID = 1;
   */
  ID: bigint;

  /**
   * @generated from field: uint64 courseCreatorID = 2;
   */
  courseCreatorID: bigint;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string code = 4;
   */
  code: string;

  /**
   * @generated from field: uint32 year = 5;
   */
  year: number;

  /**
   * @generated from field: string tag = 6;
   */
  tag: string;

  /**
   * @generated from field: uint64 ScmOrganizationID = 8;
   */
  ScmOrganizationID: bigint;

  /**
   * The organization's SCM name, e.g., dat520-2020.
   *
   * @generated from field: string ScmOrganizationName = 9;
   */
  ScmOrganizationName: string;

  /**
   * @generated from field: uint32 slipDays = 10;
   */
  slipDays: number;

  /**
   * Digest of the dockerfile used to build the course's docker image.
   *
   * @generated from field: string DockerfileDigest = 11;
   */
  DockerfileDigest: string;

  /**
   * @generated from field: qf.Enrollment.UserStatus enrolled = 12;
   */
  enrolled: Enrollment_UserStatus;

  /**
   * @generated from field: repeated qf.Enrollment enrollments = 13;
   */
  enrollments: Enrollment[];

  /**
   * @generated from field: repeated qf.Assignment assignments = 14;
   */
  assignments: Assignment[];

  /**
   * @generated from field: repeated qf.Group groups = 15;
   */
  groups: Group[];
};

/**
 * Describes the message qf.Course.
 * Use `create(CourseSchema)` to create a new message.
 */
export const CourseSchema: GenMessage<Course> = /*@__PURE__*/
  messageDesc(file_qf_types, 4);

/**
 * @generated from message qf.Courses
 */
export type Courses = Message<"qf.Courses"> & {
  /**
   * @generated from field: repeated qf.Course courses = 1;
   */
  courses: Course[];
};

/**
 * Describes the message qf.Courses.
 * Use `create(CoursesSchema)` to create a new message.
 */
export const CoursesSchema: GenMessage<Courses> = /*@__PURE__*/
  messageDesc(file_qf_types, 5);

/**
 * @generated from message qf.Repository
 */
export type Repository = Message<"qf.Repository"> & {
  /**
   * @generated from field: uint64 ID = 1;
   */
  ID: bigint;

  /**
   * @generated from field: uint64 ScmOrganizationID = 2;
   */
  ScmOrganizationID: bigint;

  /**
   * ID of a github repository
   *
   * @generated from field: uint64 ScmRepositoryID = 3;
   */
  ScmRepositoryID: bigint;

  /**
   * @generated from field: uint64 userID = 4;
   */
  userID: bigint;

  /**
   * @generated from field: uint64 groupID = 5;
   */
  groupID: bigint;

  /**
   * @generated from field: string HTMLURL = 6;
   */
  HTMLURL: string;

  /**
   * @generated from field: qf.Repository.Type repoType = 7;
   */
  repoType: Repository_Type;
};

/**
 * Describes the message qf.Repository.
 * Use `create(RepositorySchema)` to create a new message.
 */
export const RepositorySchema: GenMessage<Repository> = /*@__PURE__*/
  messageDesc(file_qf_types, 6);

/**
 * @generated from enum qf.Repository.Type
 */
export enum Repository_Type {
  /**
   * @generated from enum value: NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: INFO = 1;
   */
  INFO = 1,

  /**
   * @generated from enum value: ASSIGNMENTS = 2;
   */
  ASSIGNMENTS = 2,

  /**
   * @generated from enum value: TESTS = 3;
   */
  TESTS = 3,

  /**
   * @generated from enum value: USER = 4;
   */
  USER = 4,

  /**
   * @generated from enum value: GROUP = 5;
   */
  GROUP = 5,
}

/**
 * Describes the enum qf.Repository.Type.
 */
export const Repository_TypeSchema: GenEnum<Repository_Type> = /*@__PURE__*/
  enumDesc(file_qf_types, 6, 0);

/**
 * @generated from message qf.Enrollment
 */
export type Enrollment = Message<"qf.Enrollment"> & {
  /**
   * @generated from field: uint64 ID = 1;
   */
  ID: bigint;

  /**
   * @generated from field: uint64 courseID = 2;
   */
  courseID: bigint;

  /**
   * @generated from field: uint64 userID = 3;
   */
  userID: bigint;

  /**
   * @generated from field: uint64 groupID = 4;
   */
  groupID: bigint;

  /**
   * @generated from field: qf.User user = 5;
   */
  user?: User | undefined;

  /**
   * @generated from field: qf.Course course = 6;
   */
  course?: Course | undefined;

  /**
   * @generated from field: qf.Group group = 7;
   */
  group?: Group | undefined;

  /**
   * @generated from field: qf.Enrollment.UserStatus status = 8;
   */
  status: Enrollment_UserStatus;

  /**
   * @generated from field: qf.Enrollment.DisplayState state = 9;
   */
  state: Enrollment_DisplayState;

  /**
   * @generated from field: uint32 slipDaysRemaining = 10;
   */
  slipDaysRemaining: number;

  /**
   * @generated from field: google.protobuf.Timestamp lastActivityDate = 11;
   */
  lastActivityDate?: Timestamp | undefined;

  /**
   * @generated from field: uint64 totalApproved = 12;
   */
  totalApproved: bigint;

  /**
   * @generated from field: repeated qf.UsedSlipDays usedSlipDays = 13;
   */
  usedSlipDays: UsedSlipDays[];
};

/**
 * Describes the message qf.Enrollment.
 * Use `create(EnrollmentSchema)` to create a new message.
 */
export const EnrollmentSchema: GenMessage<Enrollment> = /*@__PURE__*/
  messageDesc(file_qf_types, 7);

/**
 * @generated from enum qf.Enrollment.UserStatus
 */
export enum Enrollment_UserStatus {
  /**
   * @generated from enum value: NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: STUDENT = 2;
   */
  STUDENT = 2,

  /**
   * @generated from enum value: TEACHER = 3;
   */
  TEACHER = 3,
}

/**
 * Describes the enum qf.Enrollment.UserStatus.
 */
export const Enrollment_UserStatusSchema: GenEnum<Enrollment_UserStatus> = /*@__PURE__*/
  enumDesc(file_qf_types, 7, 0);

/**
 * @generated from enum qf.Enrollment.DisplayState
 */
export enum Enrollment_DisplayState {
  /**
   * @generated from enum value: UNSET = 0;
   */
  UNSET = 0,

  /**
   * @generated from enum value: HIDDEN = 1;
   */
  HIDDEN = 1,

  /**
   * @generated from enum value: VISIBLE = 2;
   */
  VISIBLE = 2,

  /**
   * @generated from enum value: FAVORITE = 3;
   */
  FAVORITE = 3,
}

/**
 * Describes the enum qf.Enrollment.DisplayState.
 */
export const Enrollment_DisplayStateSchema: GenEnum<Enrollment_DisplayState> = /*@__PURE__*/
  enumDesc(file_qf_types, 7, 1);

/**
 * @generated from message qf.UsedSlipDays
 */
export type UsedSlipDays = Message<"qf.UsedSlipDays"> & {
  /**
   * @generated from field: uint64 ID = 1;
   */
  ID: bigint;

  /**
   * @generated from field: uint64 enrollmentID = 2;
   */
  enrollmentID: bigint;

  /**
   * @generated from field: uint64 assignmentID = 3;
   */
  assignmentID: bigint;

  /**
   * @generated from field: uint32 usedDays = 4;
   */
  usedDays: number;

  /**
   * @generated from field: uint64 groupID = 5;
   */
  groupID: bigint;
};

/**
 * Describes the message qf.UsedSlipDays.
 * Use `create(UsedSlipDaysSchema)` to create a new message.
 */
export const UsedSlipDaysSchema: GenMessage<UsedSlipDays> = /*@__PURE__*/
  messageDesc(file_qf_types, 8);

/**
 * @generated from message qf.Enrollments
 */
export type Enrollments = Message<"qf.Enrollments"> & {
  /**
   * @generated from field: repeated qf.Enrollment enrollments = 1;
   */
  enrollments: Enrollment[];
};

/**
 * Describes the message qf.Enrollments.
 * Use `create(EnrollmentsSchema)` to create a new message.
 */
export const EnrollmentsSchema: GenMessage<Enrollments> = /*@__PURE__*/
  messageDesc(file_qf_types, 9);

/**
 * @generated from message qf.Assignment
 */
export type Assignment = Message<"qf.Assignment"> & {
  /**
   * @generated from field: uint64 ID = 1;
   */
  ID: bigint;

  /**
   * foreign key
   *
   * @generated from field: uint64 CourseID = 2;
   */
  CourseID: bigint;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Timestamp deadline = 4;
   */
  deadline?: Timestamp | undefined;

  /**
   * @generated from field: bool autoApprove = 5;
   */
  autoApprove: boolean;

  /**
   * @generated from field: uint32 order = 6;
   */
  order: number;

  /**
   * @generated from field: bool isGroupLab = 7;
   */
  isGroupLab: boolean;

  /**
   * minimal score limit for auto approval
   *
   * @generated from field: uint32 scoreLimit = 8;
   */
  scoreLimit: number;

  /**
   * number of reviewers that will review submissions for this assignment
   *
   * @generated from field: uint32 reviewers = 9;
   */
  reviewers: number;

  /**
   * container timeout for this assignment
   *
   * @generated from field: uint32 containerTimeout = 10;
   */
  containerTimeout: number;

  /**
   * submissions produced for this assignment
   *
   * @generated from field: repeated qf.Submission submissions = 11;
   */
  submissions: Submission[];

  /**
   * grading benchmarks for this assignment
   *
   * @generated from field: repeated qf.GradingBenchmark gradingBenchmarks = 12;
   */
  gradingBenchmarks: GradingBenchmark[];

  /**
   * list of expected tests for this assignment
   *
   * @generated from field: repeated qf.TestInfo ExpectedTests = 13;
   */
  ExpectedTests: TestInfo[];
};

/**
 * Describes the message qf.Assignment.
 * Use `create(AssignmentSchema)` to create a new message.
 */
export const AssignmentSchema: GenMessage<Assignment> = /*@__PURE__*/
  messageDesc(file_qf_types, 10);

/**
 * @generated from message qf.TestInfo
 */
export type TestInfo = Message<"qf.TestInfo"> & {
  /**
   * @generated from field: uint64 ID = 1;
   */
  ID: bigint;

  /**
   * foreign key
   *
   * @generated from field: uint64 AssignmentID = 2;
   */
  AssignmentID: bigint;

  /**
   * name of the test
   *
   * @generated from field: string TestName = 3;
   */
  TestName: string;

  /**
   * max score possible to get on this test
   *
   * @generated from field: int32 MaxScore = 4;
   */
  MaxScore: number;

  /**
   * the weight of this test; used to compute final grade
   *
   * @generated from field: int32 Weight = 5;
   */
  Weight: number;

  /**
   * if populated, the frontend may display these details
   *
   * @generated from field: string Details = 6;
   */
  Details: string;
};

/**
 * Describes the message qf.TestInfo.
 * Use `create(TestInfoSchema)` to create a new message.
 */
export const TestInfoSchema: GenMessage<TestInfo> = /*@__PURE__*/
  messageDesc(file_qf_types, 11);

/**
 * @generated from message qf.Assignments
 */
export type Assignments = Message<"qf.Assignments"> & {
  /**
   * @generated from field: repeated qf.Assignment assignments = 1;
   */
  assignments: Assignment[];
};

/**
 * Describes the message qf.Assignments.
 * Use `create(AssignmentsSchema)` to create a new message.
 */
export const AssignmentsSchema: GenMessage<Assignments> = /*@__PURE__*/
  messageDesc(file_qf_types, 12);

/**
 * @generated from message qf.Submission
 */
export type Submission = Message<"qf.Submission"> & {
  /**
   * @generated from field: uint64 ID = 1;
   */
  ID: bigint;

  /**
   * foreign key
   *
   * @generated from field: uint64 AssignmentID = 2;
   */
  AssignmentID: bigint;

  /**
   * @generated from field: uint64 userID = 3;
   */
  userID: bigint;

  /**
   * @generated from field: uint64 groupID = 4;
   */
  groupID: bigint;

  /**
   * @generated from field: uint32 score = 5;
   */
  score: number;

  /**
   * @generated from field: string commitHash = 6;
   */
  commitHash: string;

  /**
   * @generated from field: repeated qf.Grade Grades = 7;
   */
  Grades: Grade[];

  /**
   * @generated from field: google.protobuf.Timestamp approvedDate = 8;
   */
  approvedDate?: Timestamp | undefined;

  /**
   * reviews produced for this submission
   *
   * @generated from field: repeated qf.Review reviews = 9;
   */
  reviews: Review[];

  /**
   * build info for tests
   *
   * @generated from field: score.BuildInfo BuildInfo = 10;
   */
  BuildInfo?: BuildInfo | undefined;

  /**
   * list of scores for different tests
   *
   * @generated from field: repeated score.Score Scores = 11;
   */
  Scores: Score[];
};

/**
 * Describes the message qf.Submission.
 * Use `create(SubmissionSchema)` to create a new message.
 */
export const SubmissionSchema: GenMessage<Submission> = /*@__PURE__*/
  messageDesc(file_qf_types, 13);

/**
 * @generated from enum qf.Submission.Status
 */
export enum Submission_Status {
  /**
   * @generated from enum value: NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: APPROVED = 1;
   */
  APPROVED = 1,

  /**
   * @generated from enum value: REJECTED = 2;
   */
  REJECTED = 2,

  /**
   * @generated from enum value: REVISION = 3;
   */
  REVISION = 3,
}

/**
 * Describes the enum qf.Submission.Status.
 */
export const Submission_StatusSchema: GenEnum<Submission_Status> = /*@__PURE__*/
  enumDesc(file_qf_types, 13, 0);

/**
 * @generated from message qf.Submissions
 */
export type Submissions = Message<"qf.Submissions"> & {
  /**
   * @generated from field: repeated qf.Submission submissions = 1;
   */
  submissions: Submission[];
};

/**
 * Describes the message qf.Submissions.
 * Use `create(SubmissionsSchema)` to create a new message.
 */
export const SubmissionsSchema: GenMessage<Submissions> = /*@__PURE__*/
  messageDesc(file_qf_types, 14);

/**
 * @generated from message qf.Grade
 */
export type Grade = Message<"qf.Grade"> & {
  /**
   * @generated from field: uint64 SubmissionID = 1;
   */
  SubmissionID: bigint;

  /**
   * @generated from field: uint64 UserID = 2;
   */
  UserID: bigint;

  /**
   * @generated from field: qf.Submission.Status Status = 3;
   */
  Status: Submission_Status;
};

/**
 * Describes the message qf.Grade.
 * Use `create(GradeSchema)` to create a new message.
 */
export const GradeSchema: GenMessage<Grade> = /*@__PURE__*/
  messageDesc(file_qf_types, 15);

/**
 * @generated from message qf.GradingBenchmark
 */
export type GradingBenchmark = Message<"qf.GradingBenchmark"> & {
  /**
   * @generated from field: uint64 ID = 1;
   */
  ID: bigint;

  /**
   * foreign key
   *
   * @generated from field: uint64 CourseID = 2;
   */
  CourseID: bigint;

  /**
   * foreign key
   *
   * @generated from field: uint64 AssignmentID = 3;
   */
  AssignmentID: bigint;

  /**
   * foreign key
   *
   * @generated from field: uint64 ReviewID = 4;
   */
  ReviewID: bigint;

  /**
   * @generated from field: string heading = 5;
   */
  heading: string;

  /**
   * @generated from field: string comment = 6;
   */
  comment: string;

  /**
   * @generated from field: repeated qf.GradingCriterion criteria = 7;
   */
  criteria: GradingCriterion[];
};

/**
 * Describes the message qf.GradingBenchmark.
 * Use `create(GradingBenchmarkSchema)` to create a new message.
 */
export const GradingBenchmarkSchema: GenMessage<GradingBenchmark> = /*@__PURE__*/
  messageDesc(file_qf_types, 16);

/**
 * @generated from message qf.Benchmarks
 */
export type Benchmarks = Message<"qf.Benchmarks"> & {
  /**
   * @generated from field: repeated qf.GradingBenchmark benchmarks = 1;
   */
  benchmarks: GradingBenchmark[];
};

/**
 * Describes the message qf.Benchmarks.
 * Use `create(BenchmarksSchema)` to create a new message.
 */
export const BenchmarksSchema: GenMessage<Benchmarks> = /*@__PURE__*/
  messageDesc(file_qf_types, 17);

/**
 * @generated from message qf.GradingCriterion
 */
export type GradingCriterion = Message<"qf.GradingCriterion"> & {
  /**
   * @generated from field: uint64 ID = 1;
   */
  ID: bigint;

  /**
   * foreign key
   *
   * @generated from field: uint64 BenchmarkID = 2;
   */
  BenchmarkID: bigint;

  /**
   * foreign key
   *
   * @generated from field: uint64 CourseID = 3;
   */
  CourseID: bigint;

  /**
   * @generated from field: uint64 points = 4;
   */
  points: bigint;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: qf.GradingCriterion.Grade grade = 6;
   */
  grade: GradingCriterion_Grade;

  /**
   * @generated from field: string comment = 7;
   */
  comment: string;
};

/**
 * Describes the message qf.GradingCriterion.
 * Use `create(GradingCriterionSchema)` to create a new message.
 */
export const GradingCriterionSchema: GenMessage<GradingCriterion> = /*@__PURE__*/
  messageDesc(file_qf_types, 18);

/**
 * @generated from enum qf.GradingCriterion.Grade
 */
export enum GradingCriterion_Grade {
  /**
   * @generated from enum value: NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: FAILED = 1;
   */
  FAILED = 1,

  /**
   * @generated from enum value: PASSED = 2;
   */
  PASSED = 2,
}

/**
 * Describes the enum qf.GradingCriterion.Grade.
 */
export const GradingCriterion_GradeSchema: GenEnum<GradingCriterion_Grade> = /*@__PURE__*/
  enumDesc(file_qf_types, 18, 0);

/**
 * @generated from message qf.Review
 */
export type Review = Message<"qf.Review"> & {
  /**
   * @generated from field: uint64 ID = 1;
   */
  ID: bigint;

  /**
   * foreign key
   *
   * @generated from field: uint64 SubmissionID = 2;
   */
  SubmissionID: bigint;

  /**
   * UserID of the reviewer
   *
   * @generated from field: uint64 ReviewerID = 3;
   */
  ReviewerID: bigint;

  /**
   * @generated from field: string feedback = 4;
   */
  feedback: string;

  /**
   * @generated from field: uint32 score = 5;
   */
  score: number;

  /**
   * @generated from field: repeated qf.GradingBenchmark gradingBenchmarks = 6;
   */
  gradingBenchmarks: GradingBenchmark[];

  /**
   * @generated from field: google.protobuf.Timestamp edited = 7;
   */
  edited?: Timestamp | undefined;
};

/**
 * Describes the message qf.Review.
 * Use `create(ReviewSchema)` to create a new message.
 */
export const ReviewSchema: GenMessage<Review> = /*@__PURE__*/
  messageDesc(file_qf_types, 19);

/**
 * @generated from message qf.AssignmentFeedback
 */
export type AssignmentFeedback = Message<"qf.AssignmentFeedback"> & {
  /**
   * @generated from field: uint64 ID = 1;
   */
  ID: bigint;

  /**
   * Required: foreign key
   *
   * @generated from field: uint64 CourseID = 2;
   */
  CourseID: bigint;

  /**
   * Required: foreign key
   *
   * @generated from field: uint64 AssignmentID = 3;
   */
  AssignmentID: bigint;

  /**
   * Required: What did you like about this assignment?
   *
   * @generated from field: string LikedContent = 4;
   */
  LikedContent: string;

  /**
   * Required: What would make it better?
   *
   * @generated from field: string ImprovementSuggestions = 5;
   */
  ImprovementSuggestions: string;

  /**
   * Required: Time used to complete the assignment
   *
   * @generated from field: uint32 TimeSpent = 6;
   */
  TimeSpent: number;

  /**
   * @generated from field: google.protobuf.Timestamp CreatedAt = 7;
   */
  CreatedAt?: Timestamp | undefined;
};

/**
 * Describes the message qf.AssignmentFeedback.
 * Use `create(AssignmentFeedbackSchema)` to create a new message.
 */
export const AssignmentFeedbackSchema: GenMessage<AssignmentFeedback> = /*@__PURE__*/
  messageDesc(file_qf_types, 20);

/**
 * @generated from message qf.FeedbackReceipt
 */
export type FeedbackReceipt = Message<"qf.FeedbackReceipt"> & {
  /**
   * @generated from field: uint64 AssignmentID = 1;
   */
  AssignmentID: bigint;

  /**
   * @generated from field: uint64 UserID = 2;
   */
  UserID: bigint;
};

/**
 * Describes the message qf.FeedbackReceipt.
 * Use `create(FeedbackReceiptSchema)` to create a new message.
 */
export const FeedbackReceiptSchema: GenMessage<FeedbackReceipt> = /*@__PURE__*/
  messageDesc(file_qf_types, 21);

/**
 * @generated from message qf.AssignmentFeedbacks
 */
export type AssignmentFeedbacks = Message<"qf.AssignmentFeedbacks"> & {
  /**
   * @generated from field: repeated qf.AssignmentFeedback feedbacks = 1;
   */
  feedbacks: AssignmentFeedback[];
};

/**
 * Describes the message qf.AssignmentFeedbacks.
 * Use `create(AssignmentFeedbacksSchema)` to create a new message.
 */
export const AssignmentFeedbacksSchema: GenMessage<AssignmentFeedbacks> = /*@__PURE__*/
  messageDesc(file_qf_types, 22);

/**
 * Note is an internal note written by teaching staff.
 * Notes are never exposed to students; access is restricted to teachers via the access control interceptor.
 * Exactly one of SubmissionID, GroupID, or EnrollmentID identifies the target the note is attached to.
 * These are plain fields rather than a oneof because Note is also the GORM model, and a oneof generates
 * an interface-typed field that GORM cannot map to columns; Submission uses plain userID and groupID
 * fields for the same reason. Note.IsValid() enforces the exactly-one invariant.
 *
 * @generated from message qf.Note
 */
export type Note = Message<"qf.Note"> & {
  /**
   * @generated from field: uint64 ID = 1;
   */
  ID: bigint;

  /**
   * foreign key; required for access control
   *
   * @generated from field: uint64 CourseID = 2;
   */
  CourseID: bigint;

  /**
   * UserID of the staff member who wrote the note
   *
   * @generated from field: uint64 AuthorID = 3;
   */
  AuthorID: bigint;

  /**
   * @generated from field: string body = 4;
   */
  body: string;

  /**
   * set if the note is attached to a submission
   *
   * @generated from field: uint64 SubmissionID = 5;
   */
  SubmissionID: bigint;

  /**
   * set if the note is attached to a group
   *
   * @generated from field: uint64 GroupID = 6;
   */
  GroupID: bigint;

  /**
   * set if the note is attached to an enrollment
   *
   * @generated from field: uint64 EnrollmentID = 7;
   */
  EnrollmentID: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp createdAt = 8;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp editedAt = 9;
   */
  editedAt?: Timestamp | undefined;
};

/**
 * Describes the message qf.Note.
 * Use `create(NoteSchema)` to create a new message.
 */
export const NoteSchema: GenMessage<Note> = /*@__PURE__*/
  messageDesc(file_qf_types, 23);

/**
 * @generated from message qf.Notes
 */
export type Notes = Message<"qf.Notes"> & {
  /**
   * @generated from field: repeated qf.Note notes = 1;
   */
  notes: Note[];
};

/**
 * Describes the message qf.Notes.
 * Use `create(NotesSchema)` to create a new message.
 */
export const NotesSchema: GenMessage<Notes> = /*@__PURE__*/
  messageDesc(file_qf_types, 24);

